import React, { useState, useEffect } from "react";
import ImageBuffer from "./ImageBuffer";
import Image from "./Image";
import Card from "./Card";
import Nav from "./Nav";
import Options from "./Options";

const Section = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState({
    flow: 0,
    section: 0,
  });
  const [quietStatus, setQuietStatus] = useState(true);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const currentSectionData =
    data[currentIndex.flow].sections[currentIndex.section];
  const bufferSectionData = data[currentIndex.flow].sections;

  const updateSection = (direction) => {
    let newSection =
      direction > 0 ? currentIndex.section + 1 : currentIndex.section - 1;
    if (
      newSection < data[currentIndex.flow].sections.length &&
      newSection > -1
    ) {
      setCurrentIndex({ flow: currentIndex.flow, section: newSection });
    } else {
      const newFlow =
        direction > 0 ? currentIndex.flow + 1 : currentIndex.flow - 1;
      if (
        currentIndex.flow < data.length &&
        newFlow < data.length &&
        newFlow > -1
      ) {
        setCurrentIndex({
          flow: newFlow,
          section: direction > 0 ? 0 : data[newFlow].sections.length - 1,
        });
      }
    }
  };

  const updateQuietStatus = () => {
    let status = !quietStatus;
    setQuietStatus(status);
  };

  const updateMenu = () => {
    let status = !isMenuVisible;
    setIsMenuVisible(status);
  };

  const calculateAspectRatioFit = (
    srcWidth,
    srcHeight,
    maxWidth,
    maxHeight,
    offset
  ) => {
    var ratio = Math.min((maxWidth - offset) / srcWidth, maxHeight / srcHeight);
    return { height: srcHeight * ratio, width: srcWidth * ratio };
  };

  const handleResize = () => {
    let imgSize = calculateAspectRatioFit(
      1920,
      1080,
      window.innerWidth,
      window.innerHeight,
      0
    );
    setImageHeight(imgSize.height);
    setImageWidth(imgSize.width);
  };

  const handleMenuItemClick = (id, e) => {
    e.preventDefault();
    setCurrentIndex({ flow: id, section: 0 });
  };

  const keyDownHandler = ({ key }) => {
    if (key === "ArrowRight") {
      updateSection(1);
    } else if (key === "ArrowLeft") {
      updateSection(-1);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    document.addEventListener("keydown", keyDownHandler);
    document.body.addEventListener("mousedown", () => {
      document.body.classList.add("using-mouse");
    });
    document.body.addEventListener("keydown", () => {
      document.body.classList.remove("using-mouse");
    });

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("keydown", keyDownHandler);
      document.body.removeEventListener("mousedown", () => {
        document.body.classList.add("using-mouse");
      });
      document.body.removeEventListener("keydown", () => {
        document.body.classList.remove("using-mouse");
      });
    };
  });

  const screenReaderText = () => {
    const slideLocation = `Step ${currentIndex.flow + 1}, Section ${
      currentIndex.section + 1
    }`;
    return (
      <div className="screenReaderText" id="screenDescription" tabIndex="0">
        <span>{slideLocation}</span>
        <div>
          <p>{currentSectionData.screenReaderText}</p>
        </div>
      </div>
    );
  };

  const renderedMenuItems = data.map((flow, index) => {
    const identifier = `${currentIndex.flow}-${currentIndex.section + 1}`;
    if (flow.sections[0].card.transition) {
      return (
        <li className="item" key={flow.id}>
          <a
            href="/"
            data-id={flow.id}
            data-identifier={identifier}
            onClick={(e) => handleMenuItemClick(index, e)}>
            {flow.sections[0].card.text}
          </a>
        </li>
      );
    } else {
      return null;
    }
  });

  const renderSlideType = () => {
    if (currentSectionData.card.transition) {
      return (
        <div
          className="app-container app-container--title"
          style={{
            width: imageWidth,
            height: imageHeight,
          }}>
          <h2>{currentSectionData.card.text}</h2>
          <div
            aria-hidden={isMenuVisible}
            className={`app-menu${isMenuVisible ? "" : " hidden"}`}>
            <div className="app-menu__inner">
              <ul>{renderedMenuItems}</ul>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="app-container"
          style={{
            width: imageWidth,
            height: imageHeight,
          }}>
          <div
            aria-hidden={isMenuVisible}
            className={`app-menu${isMenuVisible ? "" : " hidden"}`}>
            <div className="app-menu__inner">
              <ul>{renderedMenuItems}</ul>
            </div>
          </div>
          <Image images={currentSectionData.images} />
          <Card
            onNavigation={updateSection}
            card={currentSectionData.card}
            quietStatus={quietStatus}
            sequence={currentSectionData.images.sequence}
            currentIndex={currentIndex}
          />
        </div>
      );
    }
  };
  return (
    <div className="app">
      <div
        className="app-content"
        style={{
          height: imageHeight,
        }}>
        {renderSlideType()}
        <div
          className="app-options"
          style={{
            height: imageHeight,
          }}>
          <Options
            onMenu={updateMenu}
            onQuiet={updateQuietStatus}
            menuStatus={isMenuVisible}
            quietStatus={quietStatus}
            currentIndex={currentIndex}
          />
          <Nav currentIndex={currentIndex} onNavigation={updateSection} />
        </div>
      </div>
      {screenReaderText()}
      <ImageBuffer
        currentSectionIndex={currentIndex.section}
        data={bufferSectionData}
      />
    </div>
  );
};

export default Section;
